import { useEffect, useState } from "react";
import Logo from "../assets/logo.png";
import Button from "../componenet/Button";
const ThankYouPage = () => {
     const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
        setProgress((prev) => {
            if (prev >= 0.9) {
            clearInterval(interval);
            return 0.9;
            }
            return parseFloat((prev + 0.01).toFixed(2));
        });
        }, 10); 

        return () => clearInterval(interval);
    }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-10 items-center text-center text-white">
       
        <div className="flex justify-center border-b-2 border-primary rounded-xl py-2 shadow-lg bg-transparent">
            <img src={Logo} alt="logo" className="h-24" />
        </div>
       
        <div className="py-10">
            <progress
                value={progress}
                max="1"
                className="w-2/3 h-4 rounded-full overflow-hidden [&::-webkit-progress-bar]:bg-gray-600 [&::-webkit-progress-value]:bg-primary [&::-moz-progress-bar]:bg-blue-500"
            >        
            </progress>
            <h2 className="text-3xl  my-3">
                You have just <span className="text-primary">one more step </span>to guarantee your place.        
            </h2>
            <p>Here's what you must do next...</p>
        </div>

        <div className="flex flex-col md:flex-col lg:flex-row gap-6 bg-background/50 p-6 border border-gray-600 rounded-3xl max-w-4xl mx-auto">
            <div className="text-center md:text-center lg:text-left flex-2/3">
                <p className="text-2xl font-semibold">
                Join the group on WhatsApp           
                </p>
                <p className="text-xs mx-auto my-3 max-w-2xl text-gray-400">
                We constantly offer additional bonuses to the first people to join, and we always open seats for Monetise inside the Waitlist Groups before everyone else.            
                </p>
            </div>    

            <div className="flex flex-col items-center justify-center flex-1/3">
                <Button className="w-full sm:w-auto">
                JOIN THE WHATSAPP GROUP
                </Button>    

                <p className="text-xs text-gray-400 text-center mt-3">
                Not using WhatsApp? <a href="#" className="text-primary underline">Get it here.</a> It will be crucial to our communication.            
                </p>
            </div>
        </div>

      
    </div>
  )
}

export default ThankYouPage;
